import React from 'react';
import "./news.css"
import NewsPic from "../news-pic/photo_2024-11-27_11-41-53.jpg"

const News2 = () => {
    return (
        <div>
            <br/>
            <br/>
            <br/>
            <div class="news">
                <article class="news-item">
                    <div class="news-item__date">
                        <svg class="news-item__date-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#718096" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        25 ноября 2024
                    </div>

                    <h2 class="news-item__title">Меморандум о сотрудничестве подписан на форуме «Digital Tajikistan»</h2>

                    <div class="news-item__content">
                        <p>В рамках Международного Плас-Форума «Digital Tajikistan»,
проходившего 25 ноября 2024 года в Национальной библиотеке
Таджикистана был подписан меморандум о сотрудничестве между
Ассоциацией Банков Таджикистана и Центрально-Азиатской Финтек
Ассоциацией.</p>
                    </div>

                    <div class="news-item__gallery">
                        
                        <div class="news-item__image">
                            <img src={NewsPic} alt="Фото с заседания 1" />
                        </div>
                       
                    </div>
                </article>
            </div>
        </div>
    );
}

export default News2;
